'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _wrapHttpClient = require('./wrapHttpClient');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _wrapHttpClient.wrapHttpClient)(_apiClient2.default);
module.exports = exports['default'];